import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const logout = createAsyncThunk(
  "product/logout",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.post("admin/logout");
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to logout.");
    }
  }
);

// export const updateProfile = createAsyncThunk(
//   "user/updateProfile",
//   async (data, { rejectWithValue }) => {
//     try {
//       let formData = new FormData();
//       let files = [
//         "profile_image",
//         "residence_image",
//         "passbook_image",
//         "residence_image",
//         "address_proof_image",
//         "vat_certificate_image",
//         "commercial_reg_image"
//       ];
//       Object.entries(data).forEach(([key, value]) => {
//         if (files.includes(key) && !(value instanceof File)) {
//           formData.append(key, '');
//         } else if (key === "other_documents" && Array.isArray(value)) {
//           value.forEach((file) => {
//             if (file instanceof File) {
//               formData.append("other_documents[]", file);
//             }
//           });
//         } else if (value) {
//           formData.append(key, value);
//         }
//       });
      
//       const response = await api.post("admin/update-admin/"+data?.id, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       return response;
//     } catch (err) {
//       return rejectWithValue(err?.response?.data || "Failed to update profile");
//     }
//   }
// );

export const updateProfile = createAsyncThunk(
  "user/updateProfile",
  async (data, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const userId = data?.id || state.user?.user?.id || state.user?.user?._id;

      if (!userId) {
        return rejectWithValue("User ID is missing.");
      }

      let formData = new FormData();
      let files = [
        "profile_image",
        "residence_image",
        "passbook_image",
        "residence_image",
        "address_proof_image",
        "vat_certificate_image",
        "commercial_reg_image"
      ];

      Object.entries(data).forEach(([key, value]) => {
        if (files.includes(key) && !(value instanceof File)) {
          formData.append(key, '');
        } else if (key === "other_documents" && Array.isArray(value)) {
          value.forEach((file) => {
            if (file instanceof File) {
              formData.append("other_documents[]", file);
            }
          });
        } else if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });
      
      const response = await api.post(`admin/update-admin/${userId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return response;
    } catch (err) {
      return rejectWithValue(err?.response?.data || "Failed to update profile");
    }
  }
);

export const changePassword = createAsyncThunk(
  "user/changePassword",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post("admin/change-password/"+data.id, data);

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to update profile");
    }
  }
);

export const getUserProfile = createAsyncThunk(
  "user/getUserProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/get-profile`);
     
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to get user profile.");
    }
  }
);

export const getQuarterlyCommission = createAsyncThunk(
  "user/getQuarterlyCommission",
  async (data, { rejectWithValue }) => {
    try {
      // const response = await api.get(`admin/get-commission-details/${data.id}?months=${data?.months}`);
      const response = await api.get(`admin/get-profile-commission/${data.id}?months=${data?.months}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to get user commission.");
    }
  }
);
export const getOneTimeRateDetails = createAsyncThunk(
  "user/getOneTimeRateDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/get-time-rate-details/${data.id}?months=${data?.months}`);

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to get on time rate.");
    }
  }
);

export const getProfileDetailsForCommission = createAsyncThunk(
  "user/getProfileDetailsForCommission",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/get-profit-details/${data.id}?months=${data?.months}`);

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to get commition.");
    }
  }
);

export const togglePushNotification = createAsyncThunk(
  "user/togglePushNotification",
  async (value, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("push_notification", value); 

      const response = await api.post(
        "delivery-partner/push-notification-toggle",
        formData
      );

      return response; 
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || "Failed to update notification preference."
      );
    }
  }
);

const initialState = {
  user: null,
  loading: false,
  error:[],
  commissionData: [],
  onTimeRates: [],
  userCommission:[]
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
    },
    resetStatus(state) {
      state.status  = "idle";
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout.pending, (state) => {
        state.loading = true; 
      })
      .addCase(logout.fulfilled, (state, action) => {
        state.loading = false; 
      })
      .addCase(logout.rejected, (state, action) => {
        state.loading = false; 
      })
     .addCase(updateProfile.pending, (state) => {
        state.loading = true;  
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false; 
        // if (action.payload?.status) {
        //   state.user = action.payload.data;
        // }
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false; 
      })
      .addCase(changePassword.pending, (state) => {
        state.loading = true;  
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.loading = false; 
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false; 
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.user = action.payload;
      })
      .addCase(getQuarterlyCommission.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getQuarterlyCommission.fulfilled, (state, action) => {
        state.loading = false;
        state.commissionData = action.payload;
      })
      .addCase(getQuarterlyCommission.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getOneTimeRateDetails.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getOneTimeRateDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.onTimeRates = action.payload;
      })
      .addCase(getOneTimeRateDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getProfileDetailsForCommission.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getProfileDetailsForCommission.fulfilled, (state, action) => {
        state.loading = false;
        state.userCommission = action.payload?.profit_details;
      })
      .addCase(getProfileDetailsForCommission.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
    
  }
});

export const { setUser, clearUser, resetStatus } = userSlice.actions;
export default userSlice.reducer;
